import { Component, inject } from '@angular/core';

import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-ai-chat-form',
  templateUrl: 'ai-chat-form.component.html',
  styleUrls: ['./ai-chat-form.component.scss', './_ai-chat-form-theme.component.scss']
})
export class AIChatFormComponent {
  surveyEditor$ = inject(SurveyEditorService).surveyEditor$;
}
